import { SGeneralForms } from 'shj-components'
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { Radio, Select } from 'antd'
import { httpOrgList } from '@/services/homeService.ts'
import { getBrandPage, getProductCommonPage } from '@/services/product.ts'
import { isEmpty } from 'lodash-es'
import { useSetState } from 'ahooks'
import dayjs from 'dayjs'
import DebounceSelect from '@/pages/baseProduct/components/DebounceSearchSelect'
import { getGoodsPage } from '@/services/goods'

type IProps = {
  record: Record<string, any>
  chooseTypeKey?: string
  genItemId?: string
  fn: (data: Record<string, any>) => void
  setLoading: (flag: boolean) => void
}

export const AddOrEditStandard = forwardRef((props: IProps, ref) => {
  const formRef = useRef()

  const [state, setState] = useSetState<any>({
    limitTypeList: [],
    companyList: [],
  })
  const onFormRef = () => {
    const { onFormRef } = formRef.current || {}
    return onFormRef?.()
  }

  useEffect(() => {
    getOptions()
    if (!isEmpty(props.record)) {
      const obj = {
        ...props.record,
      }
      onFormRef()?.setFieldsValue(obj)
    }
  }, [props.record])

  const getOptions = async () => {
    const companyList: any = await httpOrgList()
    setState({
      companyList,
      limitTypeList: [
        { label: '黑名单', value: false },
        { label: '白名单', value: true },
      ],
    })
  }

  const onFinish = () => {
    onFormRef()
      ?.validateFields()
      .then(values => {
        props.setLoading?.(true)
        const values_ = {
          ...values,
        }
        if (props.genItemId) {
          props.fn?.(values_)
        } else {
          props.fn?.({ ...values_ })
          props.setLoading?.(false)
        }
      })
  }
  useImperativeHandle(ref, () => {
    return {
      onFinish,
    }
  }, [onFinish])

  return (
    <>
      <SGeneralForms
        ref={formRef}
        isHideGobackBtn={true}
        layout={'vertical'}
        initialValues={{
          filterType: false,
        }}
        configs={[
          {
            formItem: [
              { name: 'id', hidden: true },
              {
                name: props.record.id ? 'goodsId' : 'goodsIds',
                label: '适用商品',
                required: true,
                rules: [{ required: true, message: '适用商品不能为空' }],
                spanCol: 24,
                children: (
                  <DebounceSelect
                    allowClear
                    label={'商品'}
                    isCommon={false}
                    mode={props.record.id ? undefined : 'multiple'}
                    fixedParams={{ prodType: 'PRODUCT_PACKAGE',enabled:null, }}
                    fetchOptions={getGoodsPage}
                    fieldNames={{ label: 'goodsName', value: 'id' }}
                    nameKey={'showNameKey'}
                    query={{ id: props.record?.goodsId }}
                  />
                ),
              },
              {
                spanCol: 24,
                label: '适用门店',
                name: props.record.id ? 'companyId' : 'companyIds',
                required: true,
                rules: [{ required: true, message: '适用门店不能为空' }],
                children: (
                  <Select
                    optionFilterProp={'name'}
                    placeholder={'请选择适用门店'}
                    mode={props.record.id ? undefined : 'multiple'}
                    fieldNames={{ label: 'name', value: 'id' }}
                    options={state.companyList}
                  />
                ),
              },
              {
                spanCol: 24,
                label: '限制类型',
                name: 'filterType',
                layout: 'vertical',
                data: state.limitTypeList,
                required: true,
                rules: [{ required: true, message: '限制类型不能为空' }],
                children: (
                  <Radio.Group>
                    {state.limitTypeList.map(item => (
                      <Radio value={item.value}>{item.label}</Radio>
                    ))}
                  </Radio.Group>
                ),
              },
              {
                name: props.record.id ? 'brandId' : 'brandIds',
                label: '品牌',
                required: true,
                rules: [{ required: true, message: '品牌不能为空' }],
                spanCol: 24,
                children: (
                  <DebounceSelect
                    allowClear
                    label={'品牌'}
                    enabled={null}
                    fetchOptions={getBrandPage}
                    mode={props.record.id ? undefined : 'multiple'}
                    query={{ id: props.record?.brandId }}

                    // onChange={v => form.setFieldsValue({ [name]: v })}
                  />
                ),
              },
            ],
          },
        ]}
      />
    </>
  )
})
